import React from 'react';
import { Transition } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import envConfig from '../../../envConfig';

function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="shrink-0 border-t border-line bg-footer">
      <Transition
        appear
        show
        key="footer"
        enter="transition duration-500 ease-out"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition duration-200 ease-in"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className="flex flex-col items-center justify-center gap-1 px-4 py-5 text-sm text-muted sm:flex-row sm:gap-3"
      >
        <div>{t('copyright')} © {new Date().getFullYear()} {envConfig.SiteTitle}</div>
        <span aria-hidden="true" className="hidden text-line sm:inline">|</span>
        <div className="flex flex-row items-center gap-3">
          <a
            href={`mailto:${envConfig.ContactEmail}`}
            className="rounded text-accent tracking-tight transition-colors duration-200 ease-in-out hover:text-gold-700 hover:underline outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400"
          >
            {t('contact_us')}
          </a>
          <a
            href={envConfig.TosUrl}
            target="_blank"
            rel="noreferrer"
            className="hidden text-accent tracking-tight transition-colors duration-200 ease-in-out hover:text-gold-700 hover:underline outline-none focus:outline-none"
          >
            Terminos de Uso
          </a>
        </div>
      </Transition>
    </footer>
  );
}

export default Footer;
